export default __webpack_public_path__ + "static/media/userProfile.a747210f.svg";